/* ==========================================================================
 *  Function: Refresh images
 * ======================================================================= */
function fn_components_refresh(){
	if ($( '.js-refresh-trigger' ).length){
		$( '.js-refresh-trigger' ).on( 'click' , function () {
			var inst = $(this);
			var thisBlock = inst.closest( '.js-refresh-block' );
			var activeImg = thisBlock.find('img.is-active');
			var thisImages = thisBlock.find( '.js-refresh-images' );


			activeImg.removeClass( class_active ).next().addClass( class_active );
			if (thisBlock.find('img.is-active').index() < 0){
				thisImages.find('img:first-child').addClass( class_active );
			}
			return false;
			// if (activeImg.next())
		});
	}
}
